import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  Grid,
  TextField,
  InputAdornment,
  Typography,
  IconButton,
  Button,
  Paper,
  useMediaQuery,
  useTheme,
  Chip,
  Tabs,
  Tab,
  Modal,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Container,
  CssBaseline,
} from '@mui/material';
import AssignmentIcon from "@mui/icons-material/Assignment";
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PersonIcon from "@mui/icons-material/Person";
import DescriptionIcon from "@mui/icons-material/Description";
import CategoryIcon from "@mui/icons-material/Category";
import { MenuItem, FormControl, InputLabel, Select } from "@mui/material";
import UploadIcon from '@mui/icons-material/Upload';
import CircularProgress from "@mui/material/CircularProgress";

import {
  Search as SearchIcon,
  GroupOutlined as GroupsIcon,
  Visibility,
  Delete,
  MenuOpen as MenuOpenIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import {  CardContent } from "@mui/material";

import { useDropzone } from 'react-dropzone';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { SentimentDissatisfied, AddCircleOutline } from '@mui/icons-material';
 
const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: '24px',
  marginTop:'50px',
  overflow: 'hidden',
  boxShadow: '0 20px 40px rgba(0, 167, 111, 0.15)',
}));
 
const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '16px',
    backgroundColor: '#F3F4F6',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
    '&.Mui-focused': {
      backgroundColor: '#F9FAFB',
      '& fieldset': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
      },
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.primary.main,
  },
}));
 
const SubmitButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  padding: '14px',
  borderRadius: '16px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 600,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 16px rgba(0, 167, 111, 0.2)',
  },
}));
 
export default function DashboardRegistration() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [showDashboard, setShowDashboard] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [singleDisabled, setSingleDisabled] = useState(false);
  const [teamDisabled, setTeamDisabled] = useState(false);
  const [singleFormData, setSingleFormData] = useState({
    stud_id: '',
    project_type: '',
    project_title: '',
    project_description: '',
    pdf_files: [],
    ppt_files: [],
    video_files: [],
  });
  const maxWords = 30;

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    const words = value.split(/\s+/).filter((word) => word); // Split into words and remove empty entries

    // Prevent updating if word count exceeds maxWords
    if (words.length <= maxWords) {
      setSingleFormData({ ...singleFormData, project_description: value });
    }
  };
  const [groupFormData, setGroupFormData] = useState({
    stud_id: '',
    name_of_group: '',
    number_of_member: '',
    project_type: '',
    pdf_files: [],
    ppt_files: [],
    video_files: [],
  });
  const [previewFile, setPreviewFile] = useState(null);
  const [previewType, setPreviewType] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  // const [projectDetails, setProjectDetails] = useState(null);
 
  const [projectDetails, setProjectDetails] = useState({
    stud_name: "",
    sing_par: { project_type: "" },
    idea_dat: [],
  });
  
  const navigate = useNavigate();
  const [showCreateModal, setShowCreateModal] = useState(false);
const [groupName, setGroupName] = useState('');
const [groupDescription, setGroupDescription] = useState('');
const [showJoinModal, setShowJoinModal] = useState(false);
const [availableGroups, setAvailableGroups] = useState([]);
const [selectedGroupId, setSelectedGroupId] = useState(null);
const [showProjectModal, setShowProjectModal] = useState(false); // To open/close the modal
const [projectFormData, setProjectFormData] = useState({
  group_id: '',
  name_of_group: '',
  number_of_member: '',
  project_type: '',
  title: '',
  description: '',
  ppt_file: null,
  video_file: null,
});
const openProjectModal = (groupId, groupName) => {
  setProjectFormData({
    ...projectFormData,
    group_id: groupId,
    name_of_group: groupName,
  });
  setShowProjectModal(true);
};

const handleFileChange = (e) => {
  const { name, files } = e.target;
  
  // Check if a file is selected
  if (files && files[0]) {
    const fileName = files[0].name; // Get the name of the uploaded file

    // Update the form data with the selected files
    setTeamFormData((prev) => ({
      ...prev,
      [name]: files,
    }));

    // Trigger SweetAlert after file is selected
    Swal.fire({
      title: `${name.split('_')[0].toUpperCase()} file uploaded`,
      text: `File: ${fileName}`,
      icon: 'success',
      showCancelButton: true,
      cancelButtonText: 'Cancel Upload',
      confirmButtonText: 'Confirm Upload',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.isDismissed) {
        // If the user cancels the upload, reset the file input
        e.target.value = null;
        setTeamFormData((prev) => ({
          ...prev,
          [name]: null,
        }));
      }
    });
  } else {
    // If no file is selected, you can handle this case as needed
    Swal.fire({
      title: 'No file selected',
      text: 'Please select a file to upload.',
      icon: 'warning',
      confirmButtonText: 'Okay',
    });
  }
};

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setTeamFormData({
    ...teamFormData,
    [name]: value,
  });
};

const handleProjectSubmit = async () => {
  const storedUserId = localStorage.getItem('user_id'); // Retrieve user ID

  if (!storedUserId) {
    Swal.fire('Error', 'User ID (stud_id) is missing. Please log in again.', 'error');
    return;
  }

  try {
    const formData = new FormData();
    formData.append('group_id', projectFormData.group_id);
    formData.append('stud_id', storedUserId);
    formData.append('name_of_group', projectFormData.name_of_group);
    formData.append('number_of_member', projectFormData.number_of_member);
    formData.append('project_type', projectFormData.project_type);
    formData.append('title', projectFormData.title);
    formData.append('description', projectFormData.description);
    if (projectFormData.pdf_files) formData.append('pdf_files', projectFormData.pdf_files);

    if (projectFormData.ppt_file) formData.append('pdf_files', projectFormData.ppt_files);
    if (projectFormData.video_file) formData.append('video_file', projectFormData.video_files);

    // Submit Project API
    const response = await axios.post('https://puneexpobackend.tdtlworld.com/api/group_participant/', formData);

    Swal.fire('Success', response.data.msg, 'success');
    setShowProjectModal(false); // Close modal after success

    // Fetch updated project details
    fetchProjectDetails();
  } catch (error) {
    Swal.fire('Error', error.response?.data?.error || 'Failed to submit project.', 'error');
  }
};

const handleCreateGroup = async () => {
  const storedUserId = localStorage.getItem('user_id');
  try {
    const payload = {
      group_name: groupName,
      description: groupDescription,
      is_open_for_joining: true,
      stud_id: storedUserId,
    };
    const response = await axios.post('https://puneexpobackend.tdtlworld.com/api/create-group/', payload);

    Swal.fire('Success', response.data.message, 'success');

    // After Group Creation: Open project submission modal
    openProjectModal(response.data.group.id, response.data.group.group_name);

    setShowCreateModal(false); // Close create group modal
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Failed to create group.', 'error');
  }
};

const handleFetchGroups = async () => {
  try {
    const response = await axios.get('https://puneexpobackend.tdtlworld.com/api/all_groups/');
    setAvailableGroups(response.data); // Set fetched groups
    setShowJoinModal(true); // Open modal
  } catch (error) {
    Swal.fire('Error', 'Failed to fetch group list.', 'error');
  }
};
const handleOpenJoinModal = async () => {
  try {
    const response = await axios.get('https://puneexpobackend.tdtlworld.com/api/all_groups/');
    setAvailableGroups(response.data); // Set group list
    setShowJoinModal(true); // Open modal
  } catch (error) {
    Swal.fire('Error', 'Failed to fetch groups.', 'error');
  }
};
const handleJoinGroup = async () => {
  const storedUserId = localStorage.getItem('user_id'); // Get logged-in user ID
  if (!selectedGroupId) {
    Swal.fire('Warning', 'Please select a group to join.', 'warning');
    return;
  }

  try {
    const payload = { group_id: selectedGroupId, stud_id: storedUserId };
    const response = await axios.post('https://puneexpobackend.tdtlworld.com/api/join-group/', payload);

    Swal.fire('Success', response.data.message, 'success');
    setShowJoinModal(false); // Close modal
    setSelectedGroupId(null); // Reset selection
  } catch (error) {
    if (error.response?.data?.error === "You have already requested to join this group.") {
      Swal.fire('Info', 'You have already requested to join this group.', 'info');
    } else {
      Swal.fire('Error', error.response?.data?.error || 'Failed to join group.', 'error');
    }
  }
};


const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

  
  const { getRootProps: getPDFRootProps, getInputProps: getPDFInputProps } = useDropzone({
    onDrop: (acceptedFiles) => handleFileDrop(acceptedFiles, 'pdf'),
    accept: { 'application/pdf': ['.pdf'] },
  });
 
  const { getRootProps: getPPTRootProps, getInputProps: getPPTInputProps } = useDropzone({
    onDrop: (acceptedFiles) => handleFileDrop(acceptedFiles, 'ppt'),
    accept: { 'application/vnd.ms-powerpoint': ['.ppt', '.pptx'] },
  });
 
  const { getRootProps: getVideoRootProps, getInputProps: getVideoInputProps } = useDropzone({
    onDrop: (acceptedFiles) => handleFileDrop(acceptedFiles, 'video'),
    accept: { 'video/*': ['.mp4', '.mkv', '.avi'] },
  });
  
  
const fetchProjectDetails = async () => {
    const storedUserId = localStorage.getItem("user_id");
    const storedAuthToken = localStorage.getItem("authToken");
  
    if (storedUserId && storedAuthToken) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${storedAuthToken}`;
  
      try {
        const response = await axios.get(`https://puneexpobackend.tdtlworld.com/api/project_info/`, {
          params: { stud_id: storedUserId },
        });
  
        const { student_data, idea_data } = response.data;
  
        if (student_data && idea_data) {
          setProjectDetails({
            stud_name: student_data.full_name || "N/A",
            sing_par: { project_type: idea_data.project_type || "N/A" },
            idea_dat: [
              {
                title: idea_data.title || "N/A",
                description: idea_data.description || "N/A",
                status: idea_data.status || "N/A",
                project_type: idea_data.project_type || "N/A",
                ai_score: idea_data.ai_score || "-",
                admin_approval: idea_data.admin_approval ? "Approved" : "Pending",
                created_at: new Date(idea_data.created_at).toLocaleDateString() || "N/A",
              },
            ],
          });
        } else {
          setProjectDetails({
            stud_name: "",
            sing_par: { project_type: "N/A" },
            idea_dat: [],
          });
        }
      } catch (error) {
        console.error("Error fetching project details:", error);
        setProjectDetails({
          stud_name: "",
          sing_par: { project_type: "N/A" },
          idea_dat: [],
        });
      }
    }
  };
  
  
  useEffect(() => {
    fetchProjectDetails();
  }, []);
  
    
  const handleFileDrop = (acceptedFiles, type) => {
    const updatedFiles = acceptedFiles.map((file) => ({
      file,
      type: file.type,
    }));
 
    if (tabValue === 0) {
      setSingleFormData((prev) => ({
        ...prev,
        [`${type}_files`]: [...prev[`${type}_files`], ...updatedFiles],
      }));
    } else {
      setGroupFormData((prev) => ({
        ...prev,
        [`${type}_files`]: [...prev[`${type}_files`], ...updatedFiles],
      }));
    }
  };
 
  const handleRemoveFile = (fileToRemove, type) => {
    if (tabValue === 0) {
      setSingleFormData((prev) => ({
        ...prev,
        [`${type}_files`]: prev[`${type}_files`].filter((file) => file.file !== fileToRemove),
      }));
    } else {
      setGroupFormData((prev) => ({
        ...prev,
        [`${type}_files`]: prev[`${type}_files`].filter((file) => file.file !== fileToRemove),
      }));
    }
  };
  const [teamFormData, setTeamFormData] = useState({
    stud_id: localStorage.getItem('user_id') || '',
    name_of_group: '',
    number_of_member: '',
    project_type: '',
    title: '',
    description: '',
    pdf_files: [],
    ppt_files: [],
    video_files: [],
  });
const handleTeamSubmit = async () => {
    const wordCount = teamFormData.description.split(/\s+/).filter((word) => word).length;
    if (wordCount > 30) {
      Swal.fire('Error', 'Description must not exceed 30 words.', 'error');
      return;
    }
  
    try {
      // Show SweetAlert loader
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we submit your idea.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Show loading indicator
        },
      });
  
      const formData = new FormData();
      formData.append('stud_id', localStorage.getItem('user_id') || '');
      formData.append('name_of_group', teamFormData.name_of_group);
      formData.append('number_of_member', teamFormData.number_of_member);
      formData.append('project_type', teamFormData.project_type);
      formData.append('title', teamFormData.title);
      formData.append('description', teamFormData.description);
  
      // Append files to FormData in binary format
      if (teamFormData.pdf_files[0]) {
        formData.append('pdf_files', teamFormData.pdf_files[0]);
      }
      if (teamFormData.ppt_files[0]) {
        formData.append('ppt_files', teamFormData.ppt_files[0]);
      }
      if (teamFormData.video_files[0]) {
        formData.append('video_files', teamFormData.video_files[0]);
      }
  
      const response = await axios.post(
        'https://puneexpobackend.tdtlworld.com/api/group_participant/', 
        formData
      );
  
      // Show success alert
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
        confirmButtonColor: '#6C63FF',
      });
  
      // Reset form after successful submission
      setTeamFormData({
        stud_id: '',
        name_of_group: '',
        number_of_member: '',
        project_type: '',
        title: '',
        description: '',
        pdf_files: [],
        ppt_files: [],
        video_files: [],
      });
    } catch (error) {
      // Show error alert
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Missing required fields. pdf, ppt are required and video is optional.',
        confirmButtonColor: '#FF6B6B',
      });
    }
  };
  
  const handlePreview = (file) => {
    setPreviewFile(file.file);
    setPreviewType(file.type);
    setPreviewOpen(true);
  };
 
  const closePreview = () => {
    setPreviewOpen(false);
    setPreviewFile(null);
    setPreviewType(null);
  };

 
  const [loading, setLoading] = useState(false);


  // const handleSingleSubmit = async () => {
  //   const storedUserId = localStorage.getItem("user_id"); // Retrieve user_id from localStorage
    
  //   if (!storedUserId) {
  //     Swal.fire("Error", "User ID is missing. Please log in again.", "error");
  //     return;
  //   }
  
  //   try {
  //     // Show SweetAlert loader
  //     Swal.fire({
  //       title: 'Submitting...',
  //       // text: 'Please wait while we submit your idea .',
  //       text: 'Please wait while we submit your idea. Don\'t close this window, please stay here.',

  //       allowOutsideClick: false,
  //       didOpen: () => {
  //         Swal.showLoading(); // Show loading indicator
  //       },
  //     });
  
  //     // Prepare the payload
  //     const payload = new FormData();
  //     payload.append("stud_id", storedUserId); // Add user_id as stud_id
  //     payload.append("project_type", singleFormData.project_type);
  //     payload.append("title", singleFormData.project_title);
  //     payload.append("description", singleFormData.project_description);
  
  //     // Add uploaded files to the payload
  //     singleFormData.pdf_files.forEach(({ file }) => payload.append("pdf_files", file));
  //     singleFormData.ppt_files.forEach(({ file }) => payload.append("ppt_files", file));
  //     singleFormData.video_files.forEach(({ file }) => payload.append("video_files", file));
  
  //     // Make API call to submit the single participation project
  //     const response = await axios.post(
  //       "https://puneexpobackend.tdtlworld.com/api/single_participant/",
  //       payload
  //     );
  
  //     if (response.data.msg === "Idea submitted successfully") {
  //       // Clear the form data after a successful submission
  //       setSingleFormData({
  //         stud_id: "",
  //         project_type: "",
  //         project_title: "",
  //         project_description: "",
  //         pdf_files: [],
  //         ppt_files: [],
  //         video_files: [],
  //       });
  
  //       // Fetch updated project details and show success alert
  //       await fetchProjectDetails();
  
  //       Swal.fire({
  //         icon: "success",
  //         title: "Success",
  //         text: response.data.msg,
  //         confirmButtonColor: "#6C63FF",
  //       });
  //     }
  //   } catch (error) {
  //     // Show error alert
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: error.response?.data?.error || "Failed to submit idea.",
  //       confirmButtonColor: "#FF6B6B",
  //     });
  //   }
  // };
  // const handleSingleSubmit = async () => {
  //   const storedUserId = localStorage.getItem("user_id");
 
  //   if (!storedUserId) {
  //     Swal.fire("Error", "User ID is missing. Please log in again.", "error");
  //     return;
  //   }
 
  //   // Maximum file size in bytes (2MB)
  //   const MAX_FILE_SIZE = 2 * 1024 * 1024;
 
  //   // Helper function to check file size
  //   const isValidFileSize = (files) => {
  //     return files.every(({ file }) => file.size <= MAX_FILE_SIZE);
  //   };
 
  //   // Validate file size for each upload type
  //   if (
  //     !isValidFileSize(singleFormData.pdf_files) ||
  //     !isValidFileSize(singleFormData.ppt_files) ||
  //     !isValidFileSize(singleFormData.video_files)
  //   ) {
  //     Swal.fire("Error", "Each file must be 2MB or smaller.", "error");
  //     return;
  //   }
 
  //   try {
  //     Swal.fire({
  //       title: "Submitting...",
  //       text: "Please wait while we submit your idea. Don't close this window, please stay here.",
  //       allowOutsideClick: false,
  //       didOpen: () => {
  //         Swal.showLoading();
  //       },
  //     });
 
  //     const payload = new FormData();
  //     payload.append("stud_id", storedUserId);
  //     payload.append("project_type", singleFormData.project_type);
  //     payload.append("title", singleFormData.project_title);
  //     payload.append("description", singleFormData.project_description);
 
  //     singleFormData.pdf_files.forEach(({ file }) => payload.append("pdf_files", file));
  //     singleFormData.ppt_files.forEach(({ file }) => payload.append("ppt_files", file));
  //     singleFormData.video_files.forEach(({ file }) => payload.append("video_files", file));
 
  //     const response = await axios.post(
  //       "https://backend.punestartupexpo.com/api/single_participant/",
  //       payload
  //     );
 
  //     if (response.data.msg === "Idea submitted successfully") {
  //       setSingleFormData({
  //         stud_id: "",
  //         project_type: "",
  //         project_title: "",
  //         project_description: "",
  //         pdf_files: [],
  //         ppt_files: [],
  //         video_files: [],
  //       });
 
  //       await fetchProjectDetails();
 
  //       Swal.fire({
  //         icon: "success",
  //         title: "Success",
  //         text: response.data.msg,
  //         confirmButtonColor: "#6C63FF",
  //       });
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: error.response?.data?.error || "Failed to submit idea.",
  //       confirmButtonColor: "#FF6B6B",
  //     });
  //   }
  // };
  // const handleSingleSubmit = async () => {
  //   const storedUserId = localStorage.getItem("user_id"); // Retrieve user_id from localStorage
 
  //   if (!storedUserId) {
  //     Swal.fire("Error", "User ID is missing. Please log in again.", "error");
  //     return;
  //   }
 
  //   try {
  //     // Show SweetAlert loader
  //     Swal.fire({
  //       title: "Submitting...",
  //       text: "Please wait while we submit your idea. Don't close this window, please stay here.",
  //       allowOutsideClick: false,
  //       didOpen: () => {
  //         Swal.showLoading(); // Show loading indicator
  //       },
  //     });
 
  //     // Prepare project details payload
  //     const projectPayload = new FormData();
  //     projectPayload.append("stud_id", storedUserId);
  //     projectPayload.append("project_type", singleFormData.project_type);
  //     projectPayload.append("title", singleFormData.project_title);
  //     projectPayload.append("description", singleFormData.project_description);
 
  //     // Submit project details
  //     const projectResponse = await axios.post(
  //       "https://puneexpobackend.tdtlworld.com/api/single_participant/",
  //       projectPayload
  //     );
 
  //     if (projectResponse.data.msg !== "Idea submitted successfully") {
  //       throw new Error("Failed to submit project details.");
  //     }
 
  //     // Function to upload files
  //     const uploadFiles = async (fileType, files, apiUrl) => {
  //       if (files.length > 0) {
  //         const filePayload = new FormData();
  //         filePayload.append("stud_id", storedUserId);
 
  //         files.forEach(({ file }) => {
  //           filePayload.append(fileType, file);
  //         });
 
  //         console.log(`Uploading ${fileType} files:`, files.map(({ file }) => file.name));
 
  //         await axios.post(apiUrl, filePayload, {
  //           maxContentLength: 100 * 1024 * 1024, // 100MB
  //           maxBodyLength: 100 * 1024 * 1024, // 100MB
  //         });
  //       }
  //     };
 
  //     // Upload PPT files
  //     await uploadFiles("ppt_file", singleFormData.ppt_files, "https://puneexpobackend.tdtlworld.com/api/UploadPPTView/");
 
  //     // Upload PDF files
  //     await uploadFiles("pdf_file", singleFormData.pdf_files, "https://puneexpobackend.tdtlworld.com/api/UploadPDFView/");
 
  //     await uploadFiles("video_file", singleFormData.video_files, "https://puneexpobackend.tdtlworld.com/api/UploadVideoView/");
 
  //     // Clear form data after successful submission
  //     setSingleFormData({
  //       stud_id: "",
  //       project_type: "",
  //       project_title: "",
  //       project_description: "",
  //       pdf_files: [],
  //       ppt_files: [],
  //       video_files: [],
  //     });
 
  //     // Fetch updated project details and show success alert
  //     await fetchProjectDetails();
 
  //     Swal.fire({
  //       icon: "success",
  //       title: "Success",
  //       text: "Idea submitted successfully",
  //       confirmButtonColor: "#6C63FF",
  //     });
  //   } catch (error) {
  //     // Show error alert
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: error.response?.data?.error || "Failed to submit idea.",
  //       confirmButtonColor: "#FF6B6B",
  //     });
  //   }
  // };

  const handleSingleSubmit = async () => {
    const storedUserId = localStorage.getItem("user_id"); // Retrieve user_id from localStorage
   
    if (!storedUserId) {
      Swal.fire("Error", "User ID is missing. Please log in again.", "error");
      return;
    }
 
    try {
      // Show SweetAlert loader
      Swal.fire({
        title: 'Submitting...',
        // text: 'Please wait while we submit your idea .',
        text: 'Please wait while we submit your idea. Don\'t close this window, please stay here.',
 
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Show loading indicator
        },
      });
 
      // Prepare the payload
      const payload = new FormData();
      payload.append("stud_id", storedUserId); // Add user_id as stud_id
      payload.append("project_type", singleFormData.project_type);
      payload.append("title", singleFormData.project_title);
      payload.append("description", singleFormData.project_description);
 
      // Add uploaded files to the payload
      singleFormData.pdf_files.forEach(({ file }) => payload.append("pdf_files", file));
      singleFormData.ppt_files.forEach(({ file }) => payload.append("ppt_files", file));
      singleFormData.video_files.forEach(({ file }) => payload.append("video_files", file));
 
      // Make API call to submit the single participation project
 
      console.log("Uploading files:");
      singleFormData.pdf_files.forEach(({ file }) => console.log("PDF:", file.name, file.size));
      singleFormData.ppt_files.forEach(({ file }) => console.log("PPT:", file.name, file.size));
      singleFormData.video_files.forEach(({ file }) => console.log("Video:", file.name, file.size));
 
      const response = await axios.post(
        "https://puneexpobackend.tdtlworld.com/api/single_participant/",
        payload ,{
          maxContentLength: 100 * 1024 * 1024, // 100MB
          maxBodyLength: 100 * 1024 * 1024, // 100MB
        }
      );
 
      if (response.data.msg === "Idea submitted successfully") {
        // Clear the form data after a successful submission
        setSingleFormData({
          stud_id: "",
          project_type: "",
          project_title: "",
          project_description: "",
          pdf_files: [],
          ppt_files: [],
          video_files: [],
        });
 
        // Fetch updated project details and show success alert
        await fetchProjectDetails();
 
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.msg,
          confirmButtonColor: "#6C63FF",
        });
      }
    } catch (error) {
      // Show error alert
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.error || "Upload Failed: File size exceeds the 50MB limit.",
        confirmButtonColor: "#FF6B6B",
      });
    }
  };
  const [groupParticipants, setGroupParticipants] = useState([]);

const fetchGroupParticipants = async (groupId) => {
  try {
    const response = await axios.get(`https://puneexpobackend.tdtlworld.com/api/group_participants/`, {
      params: { group_id: groupId },
    });

    setGroupParticipants(response.data.participants);
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to fetch group participants.',
    });
  }
};

  const handleGroupSubmit = async () => {
    const storedUserId = localStorage.getItem('user_id'); // Retrieve user ID
  
    if (!storedUserId) {
      Swal.fire('Error', 'User ID is missing. Please log in again.', 'error');
      return;
    }
  
    try {
      const payload = new FormData();
      payload.append('stud_id', storedUserId); // Add user ID
      payload.append('name_of_group', groupFormData.name_of_group);
      payload.append('number_of_member', groupFormData.number_of_member);
      payload.append('project_type', groupFormData.project_type);
  
      groupFormData.pdf_files.forEach(({ file }) => payload.append('pdf_files', file));
      groupFormData.ppt_files.forEach(({ file }) => payload.append('ppt_files', file));
      groupFormData.video_files.forEach(({ file }) => payload.append('video_files', file));
  
      const response = await axios.post('https://puneexpobackend.tdtlworld.com/api/group_participant/', payload);
  
      if (response.data.message === 'Success') {
        const newGroup = response.data.group_participant;
  
        // Fetch updated group participants
        fetchGroupParticipants(newGroup.group_id);
  
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Group submission successful.',
          confirmButtonColor: '#6C63FF',
        }).then(() => {
          setTeamDisabled(true);
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.error || 'Group already submitted one idea',
        confirmButtonColor: '#FF6B6B',
      });
    }
  };
  
 
  const renderFileUploadSection = (title, rootProps, inputProps, files, type, bgColor) => (
    <Box
      sx={{
        background: bgColor,
        border: "2px dashed #6C63FF",
        padding: 3,
        textAlign: "center",
        cursor: "pointer",
        borderRadius: "12px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        "&:hover": {
          backgroundColor: "#FFFFFF",
          borderColor: "#6C63FF",
          transition: "all 0.3s ease-in-out",
          transform: "scale(1.02)",
        },
      }}
      {...rootProps}
    >
      <input {...inputProps} />
      <Typography
        variant="h6"
        sx={{
          color: "white",
          fontWeight: 700,
          mb: 1,
        }}
      >
        {title}
      </Typography>
      <Typography variant="body2" color="white">
        Drag and drop files here, or click to upload
      </Typography>
      <List sx={{ mt: 1 }}>
        {files.map((file, index) => (
          <ListItem
            key={index}
            sx={{
              background: "#FFF",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mb: 1,
            }}
          >
            <ListItemText primary={file.file.name} />
            <ListItemSecondaryAction>
              <IconButton edge="end" onClick={() => handlePreview(file)}>
                <Visibility sx={{ color: "#6C63FF" }} />
              </IconButton>
              <IconButton edge="end" onClick={() => handleRemoveFile(file.file, type)}>
                <Delete sx={{ color: "#FF5252" }} />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Box>
  );
  
  const renderTrackingCard = (item, type) => (
   
    <Card
  sx={{
    height: '100px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    p: 2,
    background: 'linear-gradient(to bottom, rgb(1, 23, 32), rgb(1, 45, 65))',
    borderRadius: '16px',
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.3)',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'translateY(-5px)',
    },
  }}
>
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <Typography
      variant="subtitle1"
      sx={{
        color: 'rgb(255, 193, 7)', // Accent color for title
        fontWeight: 'bold',
        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
      }}
    >
      {item.name}
    </Typography>
    {type === 'project' ? (
      <PersonIcon sx={{ color: 'rgb(76, 175, 80)' }} /> 
    ) : (
      <GroupsIcon sx={{ color: 'rgb(33, 150, 243)' }} /> 
    )}
  </Box>
  <Chip
    label={item.status}
    size="small"
    sx={{
      alignSelf: 'flex-start',
      bgcolor: type === 'project' ? 'rgba(76, 175, 80, 0.2)' : 'rgba(33, 150, 243, 0.2)', // Lighter background for chip
      color: type === 'project' ? 'rgb(76, 175, 80)' : 'rgb(33, 150, 243)', // Text color for chip
      fontWeight: 'bold',
    }}
  />
</Card>

  );
 

  const renderProjectDetails = () => {
    if (!projectDetails || !Array.isArray(projectDetails.idea_dat) || projectDetails.idea_dat.length === 0) {
      return (
        <Card style={{ maxWidth: 300, margin: "auto", padding: "10px" }}>
          <CardContent>
            <Typography
              style={{
                textAlign: "center",
                color: "#ff0000",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              No project ideas submitted yet. !!!
            </Typography>
          </CardContent>
        </Card>
      );
    }
  
    return projectDetails.idea_dat.map((idea, index) => (
     
      <Card
  key={index}
  style={{
    background: "linear-gradient(to bottom, rgb(1, 23, 32), rgb(1, 45, 65))",
    color: "#fff",
    borderRadius: "15px",
    boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
    margin: "15px 0",
    padding: "15px",
    overflow: "hidden",
  }}
>
  <CardContent>
    <Typography
      variant="h6"
      style={{
        fontWeight: "bold",
        marginBottom: "12px",
        color: "rgb(255, 193, 7)", // Accent color
        textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
      }}
    >
      {idea.title}
    </Typography>
    <Typography
      variant="body2"
      style={{
        marginBottom: "8px",
        borderLeft: "4px solid rgb(255, 193, 7)",
        paddingLeft: "10px",
      }}
    >
      Description: {idea.description}
    </Typography>
    <Typography
      variant="body2"
      style={{
        marginBottom: "8px",
        borderLeft: "4px solid rgb(33, 150, 243)",
        paddingLeft: "10px",
      }}
    >
      Project Type: {idea.project_type}
    </Typography>
   
    <Typography
      variant="body2"
      style={{
        marginBottom: "8px",
        borderLeft: "4px solid rgb(244, 67, 54)",
        paddingLeft: "10px",
      }}
    >
      Shortlisting status: {idea.admin_approval}
    </Typography>
    <Typography
      variant="body2"
      style={{
        marginBottom: "8px",
        borderLeft: "4px solid rgb(158, 158, 158)",
        paddingLeft: "10px",
      }}
    >
      Submitted At: {idea.created_at}
    </Typography>
    
  </CardContent>
</Card>

    ));
  };
  
  
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '80vh',
      bgcolor: '#F3F4F6',
      p: 3,
    }}>
      <CssBaseline />
      <StyledPaper sx={{ width: '100%', mb: 3 }}>
        <Box sx={{ p: 3 }}>
          {/* <Typography variant="h4" sx={{ mb: 2 }}>Dashboard & Idea Submission</Typography> */}
          {isMobile && (
            <Button
              startIcon={<MenuOpenIcon />}
              onClick={() => setShowDashboard(!showDashboard)}
              sx={{ mb: 2 }}
            >
              {showDashboard ? 'Show Submission' : 'Show Dashboard'}
            </Button>
          )}
          <Grid container spacing={3}>
            {(!isMobile || showDashboard) && (
              <Grid item xs={12} md={6}>
                <Typography variant="h6" sx={{ mb: 2 }}>Project & Group Tracking</Typography>
                <StyledTextField
                  fullWidth
                  placeholder="Search projects or groups"
                  variant="outlined"
                  sx={{ mb: 2 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
<Typography
  variant="subtitle1"
  sx={{ mb: 1, fontWeight: 'bold', textAlign: 'center' }}
>
  Projects
</Typography>
                {
                <Grid container spacing={2} sx={{ mb: 2 }}>
                {projectDetails && Array.isArray(projectDetails.idea_dat) && projectDetails.idea_dat.length > 0 ? (
                  projectDetails.idea_dat.map((project, index) => (
                    <Grid item xs={12} sm={6} key={`project-${index}`}>
                      {renderTrackingCard({ name: project.title, status: "In Progress" }, 'project')}
                    </Grid>
                  ))
                ) : (
                  <Card
                  sx={{
                    maxWidth: 400,
                    padding: 3,
                    borderRadius: 4,
                    marginTop: '3%',
                    marginLeft: '15%',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                    textAlign: 'center',
                    background: 'linear-gradient(to right,  #FFFFFF, #FF9800)', // Linear gradient background
                    color: 'white', // Updated to black text
                  }}
                  
>

<CardContent
      sx={{
        textAlign: 'center',
        background: 'linear-gradient(to bottom, #FF9800, #FFFFFF)', // Orange to White gradient
        borderRadius: 2,
        padding: 3,
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)'
      }}
    >
      {/* Icon */}
      <IconButton
        sx={{
          fontSize: 50,
          color: '#FF9800', // Orange icon
          marginBottom: 1,
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          padding: 2,
          borderRadius: '50%',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
          },
        }}
      >
        <SentimentDissatisfied fontSize="inherit" />
      </IconButton>
      
      {/* Heading */}
      <Typography
        variant="h6"
        sx={{
          color: '#212121', // Dark text for contrast
          marginBottom: 2,
        }}
      >
        Upload Your Project Details
      </Typography>
      
      {/* Description */}
      <Typography
        variant="body2"
        sx={{
          color: '#424242', // Medium-dark text for readability
          marginBottom: 3,
        }}
      >
        "Showcase Your Project: A Gateway for Investors to Fund Your Entrepreneurial Journey!"
      </Typography>
      
      {/* Add Button */}
      <IconButton
        sx={{
          color: '#FFFFFF',
          backgroundColor: '#FF9800', // Orange button
          border: '2px solid white',
          borderRadius: '50%',
          padding: 2,
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          '&:hover': {
            backgroundColor: '#E68900', // Darker orange on hover
          },
        }}
        onClick={() => setShowDashboard(!showDashboard)}
      >
        <AddCircleOutline fontSize="large" />
      </IconButton>
    </CardContent>
</Card>

              
                )}
              </Grid>
              
                /* <Grid container spacing={2} sx={{ mb: 2 }}>
                  {projectDetails && projectDetails.idea_dat.map((project, index) => (
                    <Grid item xs={12} sm={6} key={`project-${index}`}>
                      {renderTrackingCard({ name: project.title, status: "In Progress" }, 'project')}
                    </Grid>
                  ))}
                </Grid> */}
                <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>Groups</Typography>
                <Grid container spacing={2}>
                {projectDetails && projectDetails.sing_par?.project_type === "Group" && (
  <Grid item xs={12} sm={6}>
    {renderTrackingCard({ name: "Your Group", status: "Active" }, 'group')}
  </Grid>
)}

                </Grid>
                {renderProjectDetails()}
              </Grid>
            )}
            {(!isMobile || !showDashboard) && (
              <Grid item xs={12} md={6}>
                <Typography variant="h6" sx={{ mb: 2 }}>Idea Submission</Typography>
                <Tabs
                  value={tabValue}
                  onChange={(event, newValue) => setTabValue(newValue)}
                  sx={{ mb: 2 }}
                >
                  <Tab label="Single Participation" disabled={singleDisabled} />
                  <Tab label="Team Participation" disabled={teamDisabled} />
                </Tabs>
 
                {tabValue === 0 && (
                  <Box>
                    <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
  <InputLabel id="project-type-label">Project Type</InputLabel>
  <Select
    labelId="project-type-label"
    name="project_type"
    value={singleFormData.project_type}
    onChange={(e) =>
      setSingleFormData({ ...singleFormData, project_type: e.target.value })
    }
    label="Project Type"
  >
    <MenuItem value="AI/ML">AI/ML</MenuItem>
    <MenuItem value="Technology">Technology</MenuItem>
    <MenuItem value="Real Estate">Real Estate</MenuItem>
    <MenuItem value="Healthcare and Biotech">Healthcare and Biotech</MenuItem>
    <MenuItem value="Pharmacy ">Pharmacy </MenuItem>
    <MenuItem value="E-commerce and Retail">E-commerce and Retail</MenuItem>
    <MenuItem value="Education">Education</MenuItem>
    <MenuItem value="Finance and FinTech">Finance and FinTech</MenuItem>
    

    <MenuItem value="Energy and Sustainability">Energy and Sustainability</MenuItem>
    <MenuItem value="Entertainment and Media">Entertainment and Media</MenuItem>
    <MenuItem value="Agriculture and Food">Agriculture and Food</MenuItem>
    <MenuItem value="Fashion and Lifestyle">Fashion and Lifestyle</MenuItem>
    <MenuItem value="Others">Others</MenuItem>
  </Select>
</FormControl>
                    <StyledTextField
                      fullWidth
                      name="project_title"
                      label="Project Title (8 Words Max)"
                      variant="outlined"
                      value={singleFormData.project_title}
                      onChange={(e) => setSingleFormData({ ...singleFormData, project_title: e.target.value })}
                      sx={{ mb: 2 }}
                    />

                    <StyledTextField
  fullWidth
  name="project_description"
  label={`Project Description (Words: ${singleFormData.project_description.split(/\s+/).filter((word) => word).length}/${maxWords})`}
  variant="outlined"
  value={singleFormData.project_description}
  onChange={(e) => setSingleFormData({ ...singleFormData, project_description: e.target.value })}
  multiline
  rows={4}
  sx={{ mb: 2 }}
/>

<Grid container spacing={2} sx={{ mt: 0 }} alignItems="stretch">

  {/* PPT Upload */}
<Grid item xs={12} md={4}>
    {renderFileUploadSection(
      "Upload Project PPTs",
      getPPTRootProps(),
      getPPTInputProps(),
      singleFormData.ppt_files,
      "ppt",
      "linear-gradient(to right, rgb(1, 23, 32), rgb(1, 45, 65))", // Gradient Background
      "white" // White text color
    )}
  </Grid>

  {/* PDF Upload */}
  <Grid item xs={12} md={4}>
    {renderFileUploadSection(
      "Upload Project PDFs",
      getPDFRootProps(),
      getPDFInputProps(),
      singleFormData.pdf_files,
      "pdf",
      "linear-gradient(to right,  #FFFFFF, rgb(1, 45, 65))", // Gradient Background
      "white" // White text color
    )}
  </Grid>




  {/* Video Upload */}
  <Grid item xs={12} md={4}>
    {renderFileUploadSection(
      "Upload Project Videos",
      getVideoRootProps(),
      getVideoInputProps(),
      singleFormData.video_files,
      "video",
      "linear-gradient(to right, rgb(1, 23, 32), rgb(1, 45, 65))", // Gradient Background
      "white" // White text color
    )}
  </Grid>
</Grid>

<SubmitButton
        onClick={handleSingleSubmit}
        disabled={loading} // Disable button during loading
        sx={{
          mt: 2,
          background: 'linear-gradient(45deg, rgb(1, 23, 32), rgb(1, 45, 65))',
          color: 'white',
          borderRadius: '5px',
          padding: '10px 20px',
          '&:hover': {
            background: 'linear-gradient(45deg, rgb(1, 45, 65), rgb(1, 23, 32))',
          },
        }}
      >
        {loading ? (
          <CircularProgress size={20} color="inherit" sx={{ marginRight: 1 }} />
        ) : (
          "Submit Single Participation"
        )}
      </SubmitButton>


                  </Box>
                )}
 {/* Project Submission Modal */}
<Modal open={showProjectModal} onClose={() => setShowProjectModal(false)}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 500,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="h6" sx={{ mb: 2 }}>
      Submit Your Project
    </Typography>
    <TextField
      fullWidth
      label="Number of Members"
      name="number_of_member"
      value={projectFormData.number_of_member}
      onChange={handleInputChange}
      sx={{ mb: 2 }}
    />
    <TextField
      fullWidth
      label="Project Type"
      name="project_type"
      value={projectFormData.project_type}
      onChange={handleInputChange}
      sx={{ mb: 2 }}
    />
    <TextField
      fullWidth
      label="Project Title"
      name="title"
      value={projectFormData.title}
      onChange={handleInputChange}
      sx={{ mb: 2 }}
    />
    <TextField
      fullWidth
      label="Project Description"
      name="description"
      multiline
      rows={3}
      value={projectFormData.description}
      onChange={handleInputChange}
      sx={{ mb: 2 }}
    />
    <Typography sx={{ mb: 1 }}>Upload PPT File:</Typography>
    <input type="file" name="ppt_file" onChange={handleFileChange} />
    <Typography sx={{ mt: 2, mb: 1 }}>Upload Video File:</Typography>
    <input type="file" name="video_file" onChange={handleFileChange} />

    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
      <Button variant="contained" color="primary" onClick={handleProjectSubmit}>
        Submit Project
      </Button>
    </Box>
  </Box>
</Modal>

               

{tabValue === 1 && (
  <Box>
    {/* <Typography variant="h6" sx={{ mb: 2 }}>
      Team Participation
    </Typography> */}

    {/* Buttons */}
    <Box>
  <TextField
    fullWidth
    label="Group Name"
    name="name_of_group"
    value={teamFormData.name_of_group}
    onChange={handleInputChange}
    sx={{ mb: 2 }}
  />
  <TextField
    fullWidth
    label="Number of Members"
    name="number_of_member"
    value={teamFormData.number_of_member}
    onChange={handleInputChange}
    sx={{ mb: 2 }}
  />
  
  {/* Project Type Dropdown */}
  <FormControl fullWidth sx={{ mb: 2 }}>
    <InputLabel>Project Type</InputLabel>
    <Select
      name="project_type"
      value={teamFormData.project_type}
      onChange={handleInputChange}
      label="Project Type"
    >
      <MenuItem value="AI/ML">AI/ML</MenuItem>
      <MenuItem value="Technology">Technology</MenuItem>
      <MenuItem value="Real Estate">Real Estate</MenuItem>
      <MenuItem value="Healthcare and Biotech">Healthcare and Biotech</MenuItem>
      <MenuItem value="Pharmacy">Pharmacy</MenuItem>
      <MenuItem value="E-commerce and Retail">E-commerce and Retail</MenuItem>
      <MenuItem value="Education">Education</MenuItem>
      <MenuItem value="Finance and FinTech">Finance and FinTech</MenuItem>
      <MenuItem value="Energy and Sustainability">Energy and Sustainability</MenuItem>
      <MenuItem value="Entertainment and Media">Entertainment and Media</MenuItem>
      <MenuItem value="Agriculture and Food">Agriculture and Food</MenuItem>
      <MenuItem value="Fashion and Lifestyle">Fashion and Lifestyle</MenuItem>
      <MenuItem value="Others">Others</MenuItem>
    </Select>
  </FormControl>

  <TextField
    fullWidth
    label="Project Title (8 Words Max)"
    name="title"
    value={teamFormData.title}
    onChange={handleInputChange}
    sx={{ mb: 2 }}
  />

  <TextField
    fullWidth
    label={`Project Description (Words: ${teamFormData.description.split(/\s+/).filter((word) => word).length}/30)`}
    name="description"
    value={teamFormData.description}
    onChange={(e) => setTeamFormData({ ...teamFormData, description: e.target.value })}
    multiline
    rows={3}
    sx={{ mb: 2 }}
  />

  <Box sx={{ p: 3, borderRadius: 2, boxShadow: 3, backgroundColor: 'background.paper' }}>
    <Grid container spacing={3}>

    <Grid item xs={12} sm={4}>
        <Typography sx={{ mb: 1, fontWeight: 600 }}>Upload Project PPT:</Typography>
        <label htmlFor="ppt-upload">
          <input
            id="ppt-upload"
            type="file"
            name="ppt_files"
            accept=".ppt,.pptx"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          <Button variant="contained" component="span" sx={{
              background: 'linear-gradient(to bottom, rgb(1, 23, 32), rgb(1, 45, 65))',
              '&:hover': {
                background: 'linear-gradient(to bottom, rgb(1, 45, 65), rgb(1, 23, 32))',
              },
              textTransform: 'none',
              padding: '10px 20px'
            }}>
            <UploadIcon sx={{ mr: 1 }} />
            Choose PPT
          </Button>
        </label>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Typography sx={{ mb: 1, fontWeight: 600 }}>Upload Project PDF:</Typography>
        <label htmlFor="pdf-upload">
          <input
            id="pdf-upload"
            type="file"
            name="pdf_files"
            accept=".pdf"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          <Button variant="contained" component="span" sx={{
              background: 'linear-gradient(to bottom, rgb(1, 23, 32), rgb(1, 45, 65))',
              '&:hover': {
                background: 'linear-gradient(to bottom, rgb(1, 45, 65), rgb(1, 23, 32))',
              },
              textTransform: 'none',
              padding: '10px 20px'
            }}>
            <UploadIcon sx={{ mr: 1 }} />
            Choose PDF
          </Button>
        </label>
      </Grid>

  

      <Grid item xs={12} sm={4}>
        <Typography sx={{ mb: 1, fontWeight: 600 }}>Project Video:</Typography>
        <label htmlFor="video-upload">
          <input
            id="video-upload"
            type="file"
            name="video_files"
            accept="video/*"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          <Button variant="contained" component="span" sx={{
              background: 'linear-gradient(to bottom, rgb(1, 23, 32), rgb(1, 45, 65))',
              '&:hover': {
                background: 'linear-gradient(to bottom, rgb(1, 45, 65), rgb(1, 23, 32))',
              },
              textTransform: 'none',
              padding: '10px 20px'
            }}>
            <UploadIcon sx={{ mr: 1 }} />
            Choose Video
          </Button>
        </label>
      </Grid>
    </Grid>
  </Box>

  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
    {/* <SubmitButton onClick={handleTeamSubmit}>Submit Team Participation</SubmitButton> */}
    <SubmitButton 
        onClick={handleTeamSubmit} 
        disabled={loading} // Disable button during loading
        sx={{
          background: 'linear-gradient(45deg, rgb(1, 23, 32), rgb(1, 45, 65))',
          color: 'white',
          borderRadius: '5px',
          padding: '10px 20px',
          '&:hover': {
            background: 'linear-gradient(45deg, rgb(1, 45, 65), rgb(1, 23, 32))',
          },
        }}
      >
        {loading ? (
          <CircularProgress size={20} color="inherit" sx={{ marginRight: 1 }} />
        ) : (
          "Submit Team Participation"
        )}
      </SubmitButton>
  </Box>
</Box>

  </Box>
)}


<Modal open={showJoinModal} onClose={() => setShowJoinModal(false)}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 500,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="h6" sx={{ mb: 2 }}>
      Join a Group
    </Typography>

    {availableGroups.length > 0 ? (
      <List sx={{ maxHeight: 300, overflowY: 'auto' }}>
        {availableGroups.map((group) => (
         
<ListItem
  key={group.id}
  button
  disabled={group.requested} // Add a "requested" flag for groups already joined/requested
  onClick={() => setSelectedGroupId(group.id)}
  sx={{
    border: selectedGroupId === group.id ? '2px solid #6C63FF' : '1px solid #ddd',
    borderRadius: 2,
    mb: 1,
    opacity: group.requested ? 0.5 : 1,
    cursor: group.requested ? 'not-allowed' : 'pointer',
  }}
>
  <ListItemText
    primary={group.group_name}
    secondary={
      group.requested
        ? 'Join request already sent.'
        : group.description
    }
  />
</ListItem>

        ))}
      </List>
    ) : (
      <Typography>No groups available for joining.</Typography>
    )}

    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleJoinGroup}
        disabled={!selectedGroupId}
      >
        Join Group
      </Button>
    </Box>
  </Box>
</Modal>



<Modal open={showCreateModal} onClose={() => setShowCreateModal(false)}>
  <Box sx={modalStyle}>
    <Typography variant="h6" sx={{ mb: 2 }}>
      Create Group
    </Typography>
    <StyledTextField
      fullWidth
      name="group_name"
      label="Group Name"
      variant="outlined"
      value={groupName}
      onChange={(e) => setGroupName(e.target.value)}
      sx={{ mb: 2 }}
    />
    <StyledTextField
      fullWidth
      name="description"
      label="Group Description"
      variant="outlined"
      value={groupDescription}
      onChange={(e) => setGroupDescription(e.target.value)}
      multiline
      rows={3}
      sx={{ mb: 2 }}
    />
    <SubmitButton onClick={handleCreateGroup}>Create</SubmitButton>
  </Box>
</Modal>

<Modal open={showJoinModal} onClose={() => setShowJoinModal(false)}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 500,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
    }}
  >
    <Typography variant="h6" sx={{ mb: 2 }}>
      Select a Group to Join
    </Typography>

    {availableGroups.length > 0 ? (
      <List sx={{ maxHeight: 300, overflowY: 'auto' }}>
        {availableGroups.map((group) => (
          <ListItem
            key={group.id}
            button
            selected={selectedGroupId === group.id}
            onClick={() => setSelectedGroupId(group.id)}
            sx={{
              border: selectedGroupId === group.id ? '2px solid #6C63FF' : '1px solid #ddd',
              borderRadius: 2,
              mb: 1,
            }}
          >
            <ListItemText
              primary={group.group_name}
              secondary={group.description}
            />
          </ListItem>
        ))}
      </List>
    ) : (
      <Typography>No groups available.</Typography>
    )}

    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleJoinGroup}
        disabled={!selectedGroupId}
      >
        Join Group
      </Button>
    </Box>
  </Box>
</Modal>


              </Grid>
            )}
          </Grid>
        </Box>
      </StyledPaper>
 
      {/* Preview Modal */}
      <Modal open={previewOpen} onClose={closePreview}>
        <Box sx={{ width: '80%', margin: 'auto', mt: 10, bgcolor: 'background.paper', p: 4, borderRadius: 2, boxShadow: 24 }}>
          {previewFile ? (
            previewType.startsWith('video') ? (
              <video controls src={URL.createObjectURL(previewFile)} style={{ width: '100%' }} />
            ) : (
              <iframe src={URL.createObjectURL(previewFile)} title="Document Preview" style={{ width: '100%', height: '500px' }}></iframe>
            )
          ) : (
            <Typography variant="h6" color="error">
              No file selected for preview.
            </Typography>
          )}
          <Button variant="contained" onClick={closePreview} sx={{ mt: 2 }}>
            Close
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}